import '../includes/Old.css'
import { useEffect } from "react";
import { Helmet } from 'react-helmet'
import careerimg01 from '../images/img/career-img-01.png'
import careerimg02 from '../images/img/career-img-02.png'
import careerimg03 from '../images/img/career-img-03.png'
import careerimg04 from '../images/img/career-img-04.png'
import careerimg05 from '../images/img/career-img-05.png'
import AOS from "aos";
import "aos/dist/aos.css";
// import MarqueeCarousel from '../component/MainTestimonial'
import MarqueeSlider from '../component/slider/MarqueeSlider'
import JobList from '../component/career component/JobList'
import { NavLink } from 'react-router-dom'
import Cta from '../component/Cta'
export default function Career() {
    useEffect(() => {
        AOS.init({
        duration: 1000,
        once: true,
        easing: "ease-in-out",
        });

        AOS.refresh(); 
    }, []);
    
  return (
    <div>
        <Helmet>
            <title>ParcelX - Career</title>
        </Helmet>
        <section className="section01">
            <div className="container-fluid">
                <div className="">
                    <div className="col-md-11 mx-auto">
                        <div className="row align-items-center ">
                            <div className="col-md-12 border-bottom">
                              <h2 className="heading position-relative f-60 pt-4">With ParcelX – Innovate, Grow, & Make an <span>IMPACT !</span></h2>
                            </div>
                            <div className="col-md-8 mb-3">
                                <p className="f-16 pt-5 mb-0">We believe in innovation, teamwork, and making a real impact in the logistics industry. Join us and be part of a dynamic, fast-growing company that values creativity, efficiency, and excellence</p>
                            </div>
                            <div className="col-md-4 text-right pt-5 mb-3">
                                <a href="#current" className="btn btn-primary smooth-scroll me-2">Work with us</a>
                                <NavLink to='/about' className="btn btn-secondary">About Us <i className="fas fa-arrow-right"></i></NavLink>
                            </div>
                        </div> 
                    </div>
                </div>      
            </div>
        </section>
        <section className="slice pt-2">
            <div className="container-fluid">
                <div className="">
                    <div className="col-md-11 mx-auto">
                      <div className="position-relative">
                        <img src={careerimg01} className="img-fluid" width="100%" alt="" />
                        <div className="main-heading img-text">WE BUILD PRODUCT THAT CREATES <span>IMPACT</span></div>
                      </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="section slice">
            <div className="container-fluid">
                <div className="">
                    <div className="col-md-11 mx-auto">
                        <div className="row">
                            <div className="col-lg-3 col-sm-6 mb-3">
                                <div className="img-card">
                                    <img src={careerimg02} className="img-fluid" alt="" />
                                    <div className="img-card-heading">Clear <span>Communication</span></div>
                                    <p className="f-16">We are direct and succinct. We share information efficiently, emphasizing collaboration and   productivity. We practice active listening.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 mb-3">
                                <div className="img-card">
                                    <img src={careerimg03} className="img-fluid" alt="" />
                                    <div className="img-card-heading">Customer <span>Focus</span></div>
                                    <p className="f-16">We are deeply focused on solving our customers'  problems with technology. We strive to be the  most usable, trusted, and secure platform for  digital entrepreneurs.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 mb-3">
                                <div className="img-card">
                                    <img src={careerimg04} className="img-fluid" alt="" />
                                    <div className="img-card-heading">Continuous  <span>Learning</span></div>
                                    <p className="f-16">We aim to be humble and value learning above all  else. We embrace delivering and receiving candid  feedback and see every setback as an opportunity  to learn.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 mb-3">
                                <div className="img-card">
                                    <img src={careerimg05} className="img-fluid" alt="" />
                                    <div className="img-card-heading">Positive  <span>Energy</span></div>
                                    <p className="f-16">We are optimistic about building the future of  banking and determined to get there. We look for  solutions instead of choosing blame or criticism.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="slice-bg overflow-hidden">
          <div className="container-fluid">
            <div className="">
              <div className="col-md-11 mx-auto">
                  <div className="row mb-5">
                      <div className="col-md-6" data-aos="fade-right">
                          <div className="subheading f-32" data-aos="fade-right">Driving Innovation, Growth, and Impact</div>
                      </div>
                      <div className="col-md-6" data-aos="fade-left">
                          <div className="drive-line text-right fw-500" data-aos="fade-left">Drive Change</div>
                          <p className="f-20 mt-4" data-aos="fade-left">At ParcelX, we don’t just adapt to change—we create it. Our culture thrives on innovation, problem-solving, and forward-thinking strategies that make shipping seamless and efficient. Every team member plays a crucial role in driving our mission forward, ensuring that we remain a leader in the shipping industry.</p>
                      </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6" data-aos="fade-right">
                        <p className="page-heading">Diversity & Inclusion: Strength in Differences</p>
                    </div>
                    <div className="col-md-6" data-aos="fade-left" >
                        <p className="f-20 mt-4">We believe that a diverse and inclusive workforce fuels creativity and success. By valuing different perspectives, experiences, and ideas, we create a workplace where everyone can contribute, grow, and feel empowered.</p>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6" data-aos="fade-right">
                        <p className="page-heading">Celebrating Success & Every Milestone</p>
                    </div>
                    <div className="col-md-6" data-aos="fade-left">
                        <p className="f-20 mt-4">Every achievement—big or small—matters to us. We celebrate team successes, encourage a culture of recognition, and make work an enjoyable journey. At ParcelX, growth isn’t just about business—it’s about people.</p>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6" data-aos="fade-right">
                        <p className="page-heading">Encouraging Learning & Involvement</p>
                    </div>
                    <div className="col-md-6" data-aos="fade-left">
                        <p className="f-20 mt-4">We foster a culture where learning never stops. Whether it’s through mentorship programs, skill-enhancement workshops, or hands-on experiences, we ensure our team is always evolving. Employees are also encouraged to take ownership, share ideas, and actively shape the future of ParcelX.</p>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6" data-aos="fade-right">
                        <p className="page-heading">Commitment to Growth & Career Development</p>
                    </div>
                    <div className="col-md-6" data-aos="fade-left">
                        <p className="f-20 mt-4">Our greatest asset is our people. That’s why we are committed to providing a workplace that nurtures talent, encourages innovation, and offers continuous career advancement. We invest in your future so that together, we can redefine the shipping industry.</p>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </section>
        <MarqueeSlider />
        <section className="slice" id="current">
          <div className="container-fluid">
            <div className="">
              <div className="col-md-11 mx-auto">
                <div className="main-heading"><span>Current Openings: </span>Be the part of our family</div>
                <JobList />
              </div>
            </div>
          </div>
        </section>
        <Cta />
    </div>
  )
}
